<template>
  <div
    v-if="displayPosts.length"
  >
    <h2
      class="text-center text-EXPONDO-black text-2xl font-bold pt-5 pb-3.5 mx-5 lg:mx-0 lg:text-3xl lg:w-full"
    >
      {{ title }}
    </h2>
    <div class="mx-2.5 mt-3 flex lg:hidden overflow-hidden">
      <BlogSlider
        :posts="displayPosts"
        :show-title="false"
        :show-pagination-controls="showPaginationControls"
      />
    </div>
    <div class="hidden lg:flex">
      <BlogPosts
        :posts="displayPosts"
        :title="title"
        :show-title="false"
      />
    </div>
    <div
      v-if="showButton"
      class="w-auto mx-5 lg:mx-auto lg:w-96"
    >
      <CustomButton
        :type="buttonType"
        :size="buttonSize"
        :text="buttonText"
        :url="buttonLink"
      />
    </div>
  </div>
</template>

<script lang="ts">
import type { BlogCardItem } from '~~/types/blog/BlogCardItem';
import BlogSlider from '~/components/molecules/Blog/BlogSlider.vue';
import BlogPosts from '~/cms/BlogPosts/BlogPosts.vue';
import CustomButton from '~/components/atoms/Buttons/Button/CustomButton.vue';
import type { ButtonSizes, ButtonType } from '~/components/atoms/Buttons/Button/ButtonTypes';
import { ButtonSizesArray, ButtonTypesArray } from '~/components/atoms/Buttons/Button/ButtonTypes';

export default defineComponent({
  name: 'BlogPostsWithBlogLink',
  components: {
    BlogSlider,
    BlogPosts,
    CustomButton,
  },
  props: {
    posts: {
      type: Array as PropType<BlogCardItem[]>,
      default: () => [],
      validator: (posts: BlogCardItem[]) => {

        return posts.every((post) => {

          return post.author && post.createdAt && post.excerpt && post.postLink && post.thumbnail && post.title;
        
        });
      
      },
    },
    title: {
      type: String,
      required: true,
    },
    buttonType: {
      type: String as PropType<ButtonType>,
      default: 'tertiary',
      validator: (val: ButtonType) => ButtonTypesArray.includes(val),
    },
    buttonSize: {
      type: String as PropType<ButtonSizes>,
      default: 'lg',
      validator: (val: ButtonSizes) => ButtonSizesArray.includes(val),
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonLink: {
      type: String,
      default: '',
    },
    showPaginationControls: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {

    const displayPosts = props.posts.slice(0, 4);

    const showButton = computed(() => {

      return props.buttonText && props.buttonLink;
    
    });

    return {
      displayPosts,
      showButton,
    };
  
  },
});
</script>
